<template>
  <div class="page-col">
    <div class="page-main">
      <!-- Header Premium -->
      <div class="list-header-premium d-flex flex-column flex-md-row align-items-center justify-content-between gap-3 p-0 mb-3" :class="{'bg-dark border-secondary': isDark}">
        <div class="d-flex align-items-center p-3 flex-shrink-0">
          <div class="header-icon-wrapper mr-3 ml-2" style="background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);">
            <i class="fa fa-undo text-white"></i>
          </div>
          <div class="header-text-container">
            <h4 class="mb-0 font-weight-bold" :class="isDark ? 'text-white' : 'text-dark'">Devolução de Faturamento</h4>
            <p class="text-muted mb-0 small d-none d-lg-block">Gestão de retornos e cancelamentos de vendas</p>
          </div>
        </div>

        <div class="d-flex align-items-center flex-wrap gap-2 p-3 w-100 w-md-auto justify-content-end">
            <!-- Search Pill -->
            <div class="search-pill-responsive d-flex align-items-center bg-light rounded-pill p-1 shadow-xs border mr-2">
                <b-button-group class="mr-2 d-none d-lg-inline-flex">
                    <b-button variant="link" class="btn-icon-only text-muted" @click="filtro.avancado = !filtro.avancado" v-b-tooltip.hover title="Filtros Avançados">
                        <i class="fa fa-filter" :class="{'text-primary': filtro.avancado}"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-muted" @click="exportarExcel()" v-b-tooltip.hover title="Exportar Excel">
                        <i class="fa fa-file-excel-o"></i>
                    </b-button>
                    <b-button variant="link" class="btn-icon-only text-danger" @click="limpar()" v-b-tooltip.hover title="Limpar Filtros">
                        <i class="fa fa-ban"></i>
                    </b-button>
                </b-button-group>

                <div class="d-flex align-items-center px-2 border-left mr-2 date-inputs-responsive">
                    <cec-input-data ref="edDT1" v-model="dt1" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                    <span class="text-muted mx-1">até</span>
                    <cec-input-data ref="edDT2" v-model="dt2" class="mx-1" style="width: 140px" @keydown.enter.native="pesquisar()" />
                </div>
                <b-button variant="primary" pill class="btn-filtrar-responsive px-4 font-weight-bold shadow-sm text-white" :disabled="isBusy" @click="pesquisar()">
                    <i class="fa fa-search mr-1"></i> FILTRAR
                </b-button>
            </div>

            <!-- Action Buttons -->
            <b-button variant="info" pill class="btn-adicionar-responsive px-4 font-weight-bold shadow-sm" @click.stop.prevent="$router.push('/faturamento/devolucao/conferencia')">
              <i class="fa fa-clipboard mr-2"></i>
              <span class="d-none d-sm-inline">Conferencia</span>
            </b-button>
            <b-button variant="success" pill class="btn-adicionar-responsive px-4 font-weight-bold shadow-sm" @click.stop.prevent="novo()">
              <i class="fa fa-plus-circle mr-2"></i>
              <span class="d-none d-sm-inline">Nova Devolução</span>
              <span class="d-sm-none">Novo</span>
            </b-button>
        </div>
      </div>

      <!-- Advanced Filter Panel -->
      <b-collapse v-model="filtro.avancado">
          <div class="px-4 pb-4">
              <div class="card card-filter-premium p-4 border-0 shadow-sm">
                  <b-row align-v="end">
                    <b-col md="6">
                      <cliente-pesquisa 
                        @retornaId="clienteId = $event"
                        :idInicial="clienteId"
                        label="Cliente"
                        place="Busque por nome ou código..."
                        labelBotao=""
                        ref="clientepesquisa"
                        idModal="clientepesquisa"
                        @keydown.enter.native="pesquisar()"
                      />
                    </b-col>
                    <b-col md="3">
                        <label class="font-weight-bold text-muted small">Filtrar por:</label>
                        <b-form-select v-model="tipoData" class="custom-input-premium">
                            <option value="0">Data de Cadastro</option>
                            <option value="1">Data da Nota de Devolução</option>
                        </b-form-select>
                    </b-col>
                  </b-row>
                  <b-row class="mt-3">
                    <b-col md="12">
                      <label class="font-weight-bold text-muted small d-block mb-2">Situações</label>
                      <b-form-checkbox-group
                        v-model="tipoSituacao"
                        :options="filtro.tipoSituacaoOptions"
                        switches
                        class="custom-switch-premium"
                      ></b-form-checkbox-group>
                    </b-col>
                  </b-row>
              </div>
          </div>
      </b-collapse>

      <!-- Table Section -->
      <b-row class="ml-0 mr-0 p-0">
        <b-col sm="12" class="p-0">
          <b-table ref="tbl" 
                  class="modern-premium-table"
                  :dark="isDark"
                  primary-key="ID"
                  responsive hover small show-empty
                  empty-text="Nenhuma devolução encontrada para os filtros informados."
                  :busy.sync="isBusy" 
                  :items="lista" 
                  :fields="fields"
                  :current-page="currentPage"
                  :per-page="perPage"
                  @row-dblclicked="edit"
                  >
            <template #cell(STATUS)="data">
              <b-badge pill :variant="colorirStatus(data.value)">
                {{ traduzirStatus(data.value) }}
              </b-badge>
            </template>

            <template #cell(FLUXO)="data">
              <div class="devolucao-flow-badges">
                <b-badge
                  v-for="badge in fluxoBadgesListagem(data.item)"
                  :key="badge.key"
                  :variant="badge.variant"
                  pill
                  class="flow-mini-badge"
                  :title="badge.title"
                  v-b-tooltip.hover
                >
                  <i :class="badge.icon" class="mr-1"></i>{{ badge.text }}
                </b-badge>
              </div>
            </template>

            <template #cell(VALOR_VENDA)="data">
              {{ data.value | currency }}
            </template>

            <template #cell(VALOR_DEVOLUCAO_NFE)="data">
              {{ data.value | currency }}
            </template>

            <template #cell(VALOR_REPROCESSADO)="data">
              <span :class="data.value > 0 ? 'text-primary' : 'text-danger'">
                {{ data.value | currency }}
              </span>
            </template>

            <template #cell(actions)="data">
              <div class="d-flex align-items-center gap-1 justify-content-end">
                <b-button @click="edit(data.item)" variant="soft-primary" pill class="btn-icon-only shadow-sm" title="Editar" v-b-tooltip.hover>
                  <i class="fa fa-edit"></i>
                </b-button>
                <b-button @click="imprimir(data.item)" variant="soft-secondary" pill class="btn-icon-only shadow-sm" title="Imprimir" v-b-tooltip.hover>
                  <i class="fa fa-print"></i>
                </b-button>
              </div>
            </template>

            <template #empty="scope">
              <div class="text-center p-5">
                <i class="fa fa-search fa-3x text-muted mb-3"></i>
                <h5 class="text-muted">Nenhum registro encontrado</h5>
                <p class="text-muted small">Tente ajustar seus filtros de pesquisa.</p>
              </div>
            </template>
          </b-table>
        </b-col>
      </b-row>

      <!-- Pagination -->
      <div class="d-flex justify-content-between align-items-center p-3 bg-white border-top rounded-bottom shadow-sm">
        <div class="text-muted small">
          Exibindo {{ perPage * (currentPage - 1) + 1 }} - {{ Math.min(perPage * currentPage, totalRows) }} de {{ totalRows }} registros
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="right"
          size="sm"
          class="my-0"
        ></b-pagination>
      </div>

    </div>
  </div>
</template>

<script>
import moment from 'moment'
import Tools from '@/tools/tools.js'
import { createCecTableToolsMixin } from '@/mixins/cecTableTools'
import ClientePesquisa from '@/views/pesquisa/ClientePesquisa.vue'
import CecInputData from '@/components/Cec/CecInputData.vue'
import { exportExcelXlsx } from '@/utils/RelatorioHTML'

export default {
  name: 'DevolucaoFaturamentoListagem',
  components: {
    ClientePesquisa,
    CecInputData
  },
  mixins: [createCecTableToolsMixin({
    rowsProp: 'lista',
    tblRef: 'tbl',
    filters: [
      { key: 'ID', type: 'number', label: 'ID' },
      { key: 'CLIENTE_NOME', type: 'string', label: 'Cliente' },
      { key: 'VENDA_ID', type: 'number', label: 'Pedido' },
      { key: 'STATUS', type: 'string', label: 'Status' }
    ]
  })],
  data() {
    return {
      isBusy: false,
      lista: [],
      dt1: Tools.getDataAtual(),
      dt2: Tools.getDataAtual(),
      clienteId: null,
      tipoData: '0', // 0: Cadastro, 1: NFe
      tipoSituacao: ['1', '2', '3', '4', '5'],
      filtro: {
        avancado: false,
        tipoSituacaoOptions: [
          { text: 'Em Cadastro', value: '1' },
          { text: 'Distr. Conferência', value: '2' },
          { text: 'Em Conferência', value: '3' },
          { text: 'Conf. Concluída', value: '4' },
          { text: 'Concluído', value: '5' },
          { text: 'Cancelado', value: '0' }
        ]
      },
      fields: [
        { key: 'ID', label: 'ID', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'STATUS', label: 'Situação', sortable: true },
        { key: 'FLUXO', label: 'Fluxo', sortable: false, thClass: 'min-w-flow', tdClass: 'min-w-flow' },
        { 
          key: 'DATA_CADASTRO', 
          label: 'Data', 
          sortable: true, 
          formatter: v => v ? moment(v).format('DD/MM/YYYY HH:mm') : ''
        },
        { key: 'CLIENTE_NOME', label: 'Cliente', sortable: true },
        { key: 'VENDA_ID', label: 'Venda Original', sortable: true, thClass: 'text-center', tdClass: 'text-center' },
        { key: 'VALOR_VENDA', label: 'Vlr. Original', sortable: true, tdClass: 'text-right', formatter: v => Tools.formatCurrency(v) },
        { key: 'VALOR_DEVOLUCAO_NFE', label: 'Vlr. Devolvido', sortable: true, tdClass: 'text-right', formatter: v => Tools.formatCurrency(v) },
        { key: 'VALOR_REPROCESSADO', label: 'Vlr. Reproc.', sortable: true, tdClass: 'text-right', formatter: v => Tools.formatCurrency(v) },
        { key: 'actions', label: 'Ações', thClass: 'text-right' }
      ]
    }
  },
  computed: {
    isDark() {
      return this.$store.state.isDark
    },
    totalRows() {
      return this.lista.length
    }
  },
  methods: {
    pesquisar() {
      this.isBusy = true
      const filtros = {
        dt1: this.dt1,
        dt2: this.dt2,
        clienteId: this.clienteId,
        situacoes: this.tipoSituacao,
        tipoData: this.tipoData
      }
      this.$store.dispatch('devolucao/pesquisarDevolucoes', filtros)
        .then(res => {
          this.lista = res
        })
        .finally(() => {
          this.isBusy = false
        })
    },
    limpar() {
      this.dt1 = Tools.getDataAtual()
      this.dt2 = Tools.getDataAtual()
      this.clienteId = null
      this.tipoSituacao = ['1', '2', '3', '4', '5']
      this.tipoData = '0'
      this.pesquisar()
    },
    novo() {
      this.$router.push('/faturamento/devolucao/cadastro/novo')
    },
    edit(item) {
      this.$router.push(`/faturamento/devolucao/cadastro/${item.ID}`)
    },
    imprimir(item) {
      // Implementar impressão via API
      this.$toast.info('Funcionalidade de impressão em desenvolvimento')
    },
    exportarExcel() {
      const data = this.lista.map(item => ({
        ID: item.ID,
        Status: this.traduzirStatus(item.STATUS),
        Data: moment(item.DATA_CADASTRO).format('DD/MM/YYYY'),
        Cliente: item.CLIENTE_NOME,
        'Venda ID': item.VENDA_ID,
        Fluxo: this.fluxoBadgesListagem(item).map(badge => badge.text).join(' | '),
        'Valor Original': item.VALOR_VENDA,
        'Valor Devolvido': item.VALOR_DEVOLUCAO_NFE,
        'Valor Reprocessado': item.VALOR_REPROCESSADO
      }))
      exportExcelXlsx({
        rows: data,
        filename: 'Devoluções de Faturamento.xlsx'
      })
    },
    traduzirStatus(status) {
      const map = {
        '0': 'Cancelado',
        '1': 'Em Cadastro',
        '2': 'Distr. Conf.',
        '3': 'Em Conferência',
        '4': 'Conf. Concluída',
        '5': 'Concluído'
      }
      return map[status] || status
    },
    colorirStatus(status) {
      const map = {
        '0': 'danger',
        '1': 'warning',
        '2': 'info',
        '3': 'primary',
        '4': 'info',
        '5': 'success'
      }
      return map[status] || 'secondary'
    },
    fluxoBadgesListagem(item) {
      const opXml = String(item.OP_XML || '0') === '1'
      const xmlVinculado = !!item.NFE_DISTRIBUICAO_ID
      const manifestada = String(item.OP_CONFIRMAR_NFE || '0') === '1'
      const ciencia = manifestada || String(item.NFE_DISTRIBUICAO_OP_CIENCIA || '0') === '1'
      const nfeCliente = opXml || xmlVinculado
      const nfePropria = !!item.NFE_DEVOLUCAO_ID
      const nfeAutorizada = String(item.NFE_DEVOLUCAO_STATUS || '') === '2'
      const alteraFinanceiro = ['2', '3'].includes(String(item.OP_TIPO_MOVIMENTO || '3'))
      const financeiroAtualizado = String(item.OP_FINANCEIRO_ATUALIZADO || '0') === '1'

      return [
        {
          key: 'xml',
          icon: 'fa fa-file-code-o',
          text: opXml ? 'XML ok' : (xmlVinculado ? 'XML vinc.' : 'XML pend.'),
          variant: opXml ? 'success' : (xmlVinculado ? 'info' : 'secondary'),
          title: opXml
            ? 'NF-e do cliente conciliada com a devolucao.'
            : (xmlVinculado ? 'NF-e localizada em TB_NFE_DISTRIBUICAO, pendente de conciliacao final.' : 'NF-e do cliente ainda nao vinculada.')
        },
        {
          key: 'ciencia',
          icon: 'fa fa-bell-o',
          text: manifestada ? 'Manifest.' : (ciencia ? 'Ciencia' : (nfeCliente ? 'Manifest. pend.' : 'Sem SEFAZ')),
          variant: manifestada ? 'success' : (ciencia ? 'info' : (nfeCliente ? 'warning' : 'secondary')),
          title: manifestada
            ? 'Manifestacao de confirmacao registrada.'
            : (nfeCliente ? 'NF-e do cliente exige manifestacao de confirmacao antes da finalizacao.' : 'Nao ha NF-e de cliente vinculada.')
        },
        {
          key: 'conferencia',
          icon: 'fa fa-barcode',
          text: this.traduzirFluxoConferencia(item),
          variant: this.colorirFluxoConferencia(item),
          title: `${Number(item.QT_ETIQUETAS_COLETADAS) || 0} etiqueta(s) coletada(s) nesta devolucao.`
        },
        {
          key: 'nfe',
          icon: 'fa fa-file-text-o',
          text: opXml ? 'NF cliente' : (xmlVinculado ? 'NF conc.' : (nfePropria ? (nfeAutorizada ? 'NF aut.' : 'NF ger.') : 'NF opc.')),
          variant: opXml || nfeAutorizada ? 'success' : (xmlVinculado || nfePropria ? 'warning' : 'info'),
          title: opXml
            ? 'Processo usa NF-e emitida pelo cliente e conciliada.'
            : (xmlVinculado ? 'NF-e do cliente vinculada, pendente de conciliacao.' : (nfePropria ? `NF-e propria ${item.NFE_DEVOLUCAO_NUMERO || item.NFE_DEVOLUCAO_ID || ''}.` : 'NF-e propria opcional quando nao ha NF-e do cliente.'))
        },
        {
          key: 'financeiro',
          icon: 'fa fa-money',
          text: !alteraFinanceiro ? 'Sem fin.' : (financeiroAtualizado ? 'Fin. ok' : 'Fin. pend.'),
          variant: !alteraFinanceiro ? 'info' : (financeiroAtualizado ? 'success' : 'warning'),
          title: alteraFinanceiro
            ? (financeiroAtualizado ? 'Desconto financeiro da devolucao ja aplicado.' : 'Tipo de fechamento exige validacao e atualizacao do contas a receber.')
            : 'Tipo de fechamento nao altera financeiro.'
        }
      ]
    },
    traduzirFluxoConferencia(item) {
      const status = String(item.STATUS || '')
      const recepcao = String(item.OP_RECEPCAO || '0')
      if (status === '5') return 'Finalizada'
      if (status === '4' || recepcao === '3') return 'Conf. ok'
      if (status === '3' || recepcao === '2') return 'Em conf.'
      if (status === '2' || recepcao === '1') return 'Aguard. conf.'
      return 'Sem conf.'
    },
    colorirFluxoConferencia(item) {
      const status = String(item.STATUS || '')
      const recepcao = String(item.OP_RECEPCAO || '0')
      if (status === '5') return 'dark'
      if (status === '4' || recepcao === '3') return 'success'
      if (status === '3' || recepcao === '2') return 'primary'
      if (status === '2' || recepcao === '1') return 'warning'
      return 'secondary'
    }
  },
  mounted() {
    this.pesquisar()
  }
}
</script>

<style scoped>
.header-icon-wrapper {
  width: 45px;
  height: 45px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 12px;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
}

.header-icon-wrapper i {
  font-size: 20px;
}

.search-pill-responsive {
  border: 1px solid #e2e8f0;
}

.custom-input-premium {
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 0.5rem 1rem;
  height: 42px;
  transition: all 0.2s;
}

.custom-input-premium:focus {
  border-color: #667eea;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}

.card-filter-premium {
  background: #f8fafc;
  border-radius: 15px;
}

.modern-premium-table >>> th {
  background-color: #f1f5f9;
  text-transform: uppercase;
  font-size: 0.75rem;
  letter-spacing: 0.05em;
  font-weight: 700;
  color: #64748b;
  border-top: none;
  padding: 1rem 0.75rem;
}

.modern-premium-table >>> td {
  padding: 1rem 0.75rem;
  vertical-align: middle;
  font-size: 0.875rem;
  color: #334155;
  border-bottom: 1px solid #f1f5f9;
}

.modern-premium-table >>> .min-w-flow {
  min-width: 310px;
}

.devolucao-flow-badges {
  display: flex;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 360px;
}

.flow-mini-badge {
  font-size: 0.68rem;
  font-weight: 700;
  line-height: 1.35;
  padding: 0.32rem 0.5rem;
}

.gap-1 { gap: 0.25rem; }
.gap-2 { gap: 0.5rem; }
.gap-3 { gap: 1rem; }

.btn-icon-only {
  width: 38px;
  height: 38px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.shadow-xs {
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
}
</style>



// WEBPACK FOOTER //
// src/views/faturamento/devolucao/DevolucaoFaturamentoListagem.vue